export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/Hyundai/theme/components/scorecard/MetricsLabels/index.js